import {checkPassport} from '@router/guards/roleGuard'
export default {
  path: '/buyer',
  component: () => import('@views/Buyer/Index'),
  beforeEnter: checkPassport,
  children: [
    {
      path: 'index',
      name: 'buyer.index',
      component: () => import('@/components/Buyer/Buyer')
    },
  ]
}
